import { useDispatch } from 'react-redux';
import { setAuth } from '../features/auth/authSlice';
import { instance } from '../utils/axios';

const useRefreshToken = () => {
    const dispatch = useDispatch();
    const refresh = async () => {
        try {
            const response = await instance.get('/refresh',
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            dispatch(setAuth({ accessToken: response.data.accessToken }))
            return response.data.accessToken;
        } catch (err) {
            throw new Error(err)
        }
    }
    return refresh;
};

export default useRefreshToken;